export function getUpdateFormDataReducer(state, action) {
	return {
		...state,
		exchangedData: action.exchangedData,
	};
}
